.fp-staff-layout
  .fp-staff-layout--modal
    .fp-modal
      LoginFormVue(is-redirecting)
